import React, { Component } from "react";
import {
    is
} from "ramda";
import { basicBlack } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import { Button } from "@maxmilhas/hangar-components-atomic/public";

export default class CancellationButton extends Component {
	constructor(props) {        
		super(props);
		this.CANCELED = "CANCELADO";
		this.CANCELING = "CANCELANDO";
		this.state = {
			tripStatus: props.trip.order.status
        };
        this.handle = this.handle.bind(this);
	}

    changeButtonTitle(tripStatus) {
        let title = 'Cancelar o Voo';
        switch (tripStatus) {
            case this.CANCELED:
                title = 'Este voo já se encontra cancelado.';
                break;
            case this.CANCELING:
                title = 'Você não pode solicitar o cancelamento desse voo, porque já existe uma solicitação em andamento';
                break;
            default:
                title = 'Cancelar o Voo';
        }
        return title;
    }

    /**
     * TODO: [OPE-2886] Alterar o nome da prop callback para OnClick para melhoria de semantica do código. Pois uma propriedade com nome callback, não
     * passa nenhuma referencia de como a função será executada. Após realizar a alteração alterar os componentes que utiliza-se do mesmo.
     */
    handle() {
        const { callback, trip: { flights, order } } = this.props;
        if ((flights.outbound && flights.outbound.airline.toLowerCase() === 'avianca') ||
            (flights.inbound && flights.inbound.airline.toLowerCase() === 'avianca')) {
            window.open('https://ajuda.maxmilhas.com.br/duvidas-sobre-os-voos-avianca', '_blank');
        } else {
            if (typeof callback === "function") {
                callback(order.code);
            }
        }
    }

    render() {
        const { tripStatus } = this.state;
        const { outline, text, callback, trip, ...rest } = this.props;
        const title = this.changeButtonTitle(tripStatus);
        const disabled = tripStatus === this.CANCELING || tripStatus === this.CANCELED;

        return (
            <div title={title} >

                <Button
                    onClick={this.handle}
                    disabled={disabled}
                    size="small"
                    outline={outline}
                    color={disabled ? basicBlack : undefined}
                    
                    {...rest}
                >
                    {text ? text : 'Como cancelar?'}
                </Button>
            </div>
        );

    }
}